import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Api from '../utils/Api';
import "../style/Login.css";

import logo from '../assets/ranky-logo-text-blue-gradient.png';

// Login Component
class Login extends Component {
  constructor() {
    super();
    this.state = {
      username: '',
      password: '',
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.submit = this.submit.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  submit(e) {
    e.preventDefault();
    Api.login(this.state.username, this.state.password)
    .then(res => {
      if (res.token) {
        localStorage.setItem('token', res.token);
        this.setState({ redirect : true })
      }
    }).catch(err => {
      this.setState({ error : true })
    });
  }

  render() {
    const errorAlert = (
      <div className="alert alert-warning">
        Identifiants incorrects. Merci de rééssayer.
      </div>
    );

    if (this.state.redirect)
      return <Redirect to='/app' />

    return(
        <div className="login-wrapper">
          <div className="login-box card">
            <div className="logo-wrapper">
              <img className="logo" src={logo} alt="Ranky logo"/>
            </div>
            <form onSubmit={this.submit}>
              <div className="form-group">
                <label htmlFor="email">
                  <i className="pe-7s-mail gradient-icon-blue"></i>
                  Adresse e-mail
                </label>
                <input value={this.state.username} onChange={this.handleInputChange} type="email" className="form-control" name="username" id="email" aria-describedby="email" required/>
              </div>
              <div className="form-group">
                <label htmlFor="password">
                  <i className="pe-7s-key gradient-icon-blue"></i>
                  Mot de passe
                </label>
                <input value={this.state.password} onChange={this.handleInputChange} type="password" className="form-control" id="password" name="password" />
              </div>
              <a className="forgotpw" href="/forgotpassword">Mot de passe oublié ?</a>
              <hr/>
              { this.state.error && errorAlert }
              <button type="submit" className="btn btn-primary btn-block" disabled={!(this.state.username.length && this.state.password.length)}>
                <i className="pe-7s-check gradient-icon-green-blue"></i>
                Connexion
              </button>
            </form>
          </div>
        </div>
    );
  }
}
export default Login;



// WEBPACK FOOTER //
// ./src/containers/Login.js